import React from 'react'
import Drawer from '@softwaredev_cegeka/stix-core/dist/components/Drawer'
import { usePushDrawer } from 'src/hooks/usePushDrawer'

// Styles
import styles from './pushDrawer.module.scss'

function PushDrawer({ children }) {
    const { pushDrawerConfig } = usePushDrawer()
    const {
        title,
        pushDrawerIsOpen = false,
        onClosePushDrawer,
    } = pushDrawerConfig

    return (
        <>
            <Drawer
                isOpen={pushDrawerIsOpen}
                position="right"
                type="sticky"
                panelTitle={title}
                panelContent={
                    <div
                        id="push-drawer-content-portal"
                        className={styles.pushDrawerPortal}
                    />
                }
                onClose={() => onClosePushDrawer()}
                drawerDetailClassName={styles.pushDrawerDetail}
            >
                {children}
            </Drawer>
        </>
    )
}

export default PushDrawer
